import { history } from "redux/configureStore";
import {
  LOGIN,
  // REQUEST_COMPLETE,
  REQUEST_SUCCESS,
  REQUEST,
  REQUEST_FAIL,
  REQUEST_MYSELF_SUCCESS,
  REQUEST_MYSELF_FAIL
} from "./constants";
import API from "redux/api/authenticate";
import { loadAll as loadSites } from "redux/sites/actions";

export const loadStart = () => ({ type: REQUEST });

export const loginRedirect = () => {
  history.push(`/login`);
  return {
    type: LOGIN
  };
};

export const receiveFail = ({ errors, status }) => ({
  type: REQUEST_FAIL,
  errors,
  status
});

export const myself = () => dispatch =>
  API.myself().then(response =>
    response
      .json()
      .then(json => ({
        ok: response.ok,
        status: response.status,
        json
      }))
      .then(
        ({ json, ok, status }) =>
          ok
            ? dispatch({ type: REQUEST_MYSELF_SUCCESS, payload: json })
            : dispatch({ type: REQUEST_MYSELF_FAIL })
      )
  );

export const logout = () => dispatch =>
  API.logout().then(() => (window.location = "/"));

export function login(data) {
  return dispatch => {
    dispatch(loadStart());
    return (
      API.login(data)
        // .then(response => {
        //   return response.json().then(json => ({
        //     ok: response.ok,
        //     status: response.status
        //     json
        //   }));
        // })
        .then(({ ok, status }) => {
          if (ok) {
            history.push(`/`);
            // dispatch({ type: REQUEST_SUCCESS, payload: { name: data.login } });
            dispatch({ type: REQUEST_SUCCESS });
            dispatch(myself());
            dispatch(loadSites());
          } else if (status === 401) {
            dispatch(
              receiveFail({ errors: "Неправильный логин или пароль", status })
            );
          }
          // return dispatch({
          //   type: REQUEST_COMPLETE
          //   // payload: { name: data.login }
          // });
        })
        .catch(errors => dispatch(receiveFail({ errors })))
    );
  };
}
